import { useLocation, useNavigate } from 'react-router-dom'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/shadcn/ui/dropdown-menu'
import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'
import { FeeImmunityIcon } from '~/@mid_ui/icons/FeeImmunityIcon'
import { LogoutButton } from '../logout-button/LogoutButton'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  accountName: React.ReactNode
  isProfileLinkVisible: boolean
  showFeeImmunityLink: boolean
  triggerClassname?: string
}

function AccountMenu({
  accountName,
  isProfileLinkVisible = true,
  showFeeImmunityLink,
  triggerClassname,
}: Props) {
  const navigate = useNavigate()
  const location = useLocation()

  function getActiveClassName(checkedPathname: string) {
    return location.pathname === checkedPathname
      ? 'text-accent'
      : 'text-primary'
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn('cursor-pointer focus:outline-none', triggerClassname)}>
        {accountName}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        className="bg-background p-4">
        {isProfileLinkVisible && (
          <DropdownMenuItem
            onClick={() => {
              navigate('/settings/profile')
            }}
            className={getActiveClassName('/settings/profile')}>
            <GraphIcon
              className={`w-6! h-6! ${getActiveClassName('/settings/profile')}`}
            />
            Nastavenia účtu
          </DropdownMenuItem>
        )}

        {showFeeImmunityLink && (
          <DropdownMenuItem
            onClick={() => {
              navigate('/fee-immunity')
            }}
            className={getActiveClassName('/fee-immunity')}>
            <FeeImmunityIcon
              className={`w-6! h-6! text-primary ${getActiveClassName('/fee-immunity')}`}
            />
            Poplatková imunita
          </DropdownMenuItem>
        )}

        <DropdownMenuItem>
          <LogoutButton
            variant="outline"
            className="w-full border-primary text-primary"
          />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { AccountMenu }
